import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_UTIMACO_CIRCUIT_SWITCH = '/utmisdncfcis';

export const SET_UTIMACO_CIRCUIT_SWITCH_LOADING = 'SET_UTIMACO_CIRCUIT_SWITCH_LOADING';
export const GO_TO_UTIMACO_CIRCUIT_SWITCH_CREATE = 'GO_TO_UTIMACO_CIRCUIT_SWITCH_CREATE';
export const GO_TO_UTIMACO_CIRCUIT_SWITCH_EDIT = 'GO_TO_UTIMACO_CIRCUIT_SWITCH_EDIT';
export const GO_TO_UTIMACO_CIRCUIT_SWITCH_VIEW = 'GO_TO_UTIMACO_CIRCUIT_SWITCH_VIEW';
export const GO_TO_UTIMACO_CIRCUIT_SWITCH_COPY = 'GO_TO_UTIMACO_CIRCUIT_SWITCH_COPY';
export const GO_TO_UTIMACO_CIRCUIT_SWITCH_LIST = 'GO_TO_UTIMACO_CIRCUIT_SWITCH_LIST';
export const GET_UTIMACO_CIRCUIT_SWITCH_LIST = 'GET_UTIMACO_CIRCUIT_SWITCH_LIST';
export const GET_UTIMACO_CIRCUIT_SWITCH_LIST_PENDING = 'GET_UTIMACO_CIRCUIT_SWITCH_LIST_PENDING';
export const GET_UTIMACO_CIRCUIT_SWITCH_LIST_FULFILLED = 'GET_UTIMACO_CIRCUIT_SWITCH_LIST_FULFILLED';
export const GET_UTIMACO_CIRCUIT_SWITCH = 'GET_UTIMACO_CIRCUIT_SWITCH';
export const GET_UTIMACO_CIRCUIT_SWITCH_PENDING = 'GET_UTIMACO_CIRCUIT_SWITCH_PENDING';
export const GET_UTIMACO_CIRCUIT_SWITCH_FULFILLED = 'GET_UTIMACO_CIRCUIT_SWITCH_FULFILLED';
export const CREATE_UTIMACO_CIRCUIT_SWITCH = 'CREATE_UTIMACO_CIRCUIT_SWITCH';
export const CREATE_UTIMACO_CIRCUIT_SWITCH_PENDING = 'CREATE_UTIMACO_CIRCUIT_SWITCH_PENDING';
export const CREATE_UTIMACO_CIRCUIT_SWITCH_FULFILLED = 'CREATE_UTIMACO_CIRCUIT_SWITCH_FULFILLED';
export const CREATE_UTIMACO_CIRCUIT_SWITCH_REJECTED = 'CREATE_UTIMACO_CIRCUIT_SWITCH_REJECTED';
export const UPDATE_UTIMACO_CIRCUIT_SWITCH = 'UPDATE_UTIMACO_CIRCUIT_SWITCH';
export const UPDATE_UTIMACO_CIRCUIT_SWITCH_FULFILLED = 'UPDATE_UTIMACO_CIRCUIT_SWITCH_FULFILLED';
export const UPDATE_UTIMACO_CIRCUIT_SWITCH_REJECTED = 'UPDATE_UTIMACO_CIRCUIT_SWITCH_REJECTED';
export const DELETE_UTIMACO_CIRCUIT_SWITCH = 'DELETE_UTIMACO_CIRCUIT_SWITCH';
export const DELETE_UTIMACO_CIRCUIT_SWITCH_FULFILLED = 'DELETE_UTIMACO_CIRCUIT_SWITCH_FULFILLED';
export const DELETE_UTIMACO_CIRCUIT_SWITCH_REJECTED = 'DELETE_UTIMACO_CIRCUIT_SWITCH_REJECTED';
export const SELECT_UTIMACO_CIRCUIT_SWITCH = 'SELECT_UTIMACO_CIRCUIT_SWITCH';

export enum UtimacoCircuitSwitchPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export interface UtimacoCircuitSwitch {
  id?: string;
  CFID: string;
  AFID: string;
  ISDN: string;
  LEA: string;
  CCCMCID: string;
  CUGILC: string;
  CUGDNIC: string;
  CPRISDN: string;
  SS8ID?: string;
  OWNER?: string;
  GROUP?: string;
  ACCESS?: string;
}

export interface UtimacoCircuitSwitchState {
  entities: UtimacoCircuitSwitch[]
  selected: UtimacoCircuitSwitch[],
  single: UtimacoCircuitSwitch | null
  createdId: string | null
  ui: UtimacoCircuitSwitchsUIState
}

export interface UtimacoCircuitSwitchsUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GoToUtimacoCircuitSwitchListAction extends AnyAction {
  type: typeof GO_TO_UTIMACO_CIRCUIT_SWITCH_LIST
}

export interface SetUtimacoCircuitSwitchLoadingAction extends AnyAction {
  type: typeof SET_UTIMACO_CIRCUIT_SWITCH_LOADING
  payload: { isLoading: boolean }
}

export interface GetUtimacoCircuitSwitchListAction extends AnyAction {
  type: typeof GET_UTIMACO_CIRCUIT_SWITCH_LIST
  payload: AxiosPromise<ServerResponse<UtimacoCircuitSwitch>>
}

export interface GetUtimacoCircuitSwitchListPendingAction extends AnyAction {
  type: typeof GET_UTIMACO_CIRCUIT_SWITCH_LIST_PENDING
  payload: null
}

export interface GetUtimacoCircuitSwitchListFulfilledAction extends AnyAction {
  type: typeof GET_UTIMACO_CIRCUIT_SWITCH_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<UtimacoCircuitSwitch>>
}

export interface GetUtimacoCircuitSwitchAction extends AnyAction {
  type: typeof GET_UTIMACO_CIRCUIT_SWITCH
  payload: AxiosPromise<ServerResponse<UtimacoCircuitSwitch>>
}

export interface GetUtimacoCircuitSwitchPendingAction extends AnyAction {
  type: typeof GET_UTIMACO_CIRCUIT_SWITCH_PENDING
  payload: null
}

export interface GetUtimacoCircuitSwitchFulfilledAction extends AnyAction {
  type: typeof GET_UTIMACO_CIRCUIT_SWITCH_FULFILLED
  payload: AxiosResponse<ServerResponse<UtimacoCircuitSwitch>>
}

export interface CreateUtimacoCircuitSwitchThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface CreateUtimacoCircuitSwitchAction extends AnyAction {
  type: typeof CREATE_UTIMACO_CIRCUIT_SWITCH
  payload: AxiosPromise<ServerResponse<UtimacoCircuitSwitch>>
}

export interface CreateUtimacoCircuitSwitchPendingAction extends AnyAction {
  type: typeof CREATE_UTIMACO_CIRCUIT_SWITCH_PENDING
  payload: null
}

export interface CreateUtimacoCircuitSwitchFulfilledAction extends AnyAction {
  type: typeof CREATE_UTIMACO_CIRCUIT_SWITCH_FULFILLED
  payload: AxiosResponse<ServerResponse<UtimacoCircuitSwitch>>
}

export interface CreateUtimacoCircuitSwitchRejectedAction extends AnyAction {
  type: typeof CREATE_UTIMACO_CIRCUIT_SWITCH_REJECTED
  payload: AxiosResponse<ServerResponse<UtimacoCircuitSwitch>>
}

export interface UpdateUtimacoCircuitSwitchThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface UpdateUtimacoCircuitSwitchAction extends AnyAction {
  type: typeof UPDATE_UTIMACO_CIRCUIT_SWITCH
  payload: AxiosPromise<ServerResponse<UtimacoCircuitSwitch>>
}

export interface UpdateUtimacoCircuitSwitchFulfilledAction extends AnyAction {
  type: typeof UPDATE_UTIMACO_CIRCUIT_SWITCH_FULFILLED
  payload: AxiosResponse<ServerResponse<UtimacoCircuitSwitch>>
}

export interface UpdateUtimacoCircuitSwitchRejectedAction extends AnyAction {
  type: typeof UPDATE_UTIMACO_CIRCUIT_SWITCH_REJECTED
  payload: AxiosResponse<ServerResponse<UtimacoCircuitSwitch>>
}

export interface DeleteUtimacoCircuitSwitchThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface DeleteUtimacoCircuitSwitchAction extends AnyAction {
  type: typeof DELETE_UTIMACO_CIRCUIT_SWITCH
  payload: AxiosPromise<ServerResponse<UtimacoCircuitSwitch>>
}

export interface DeleteUtimacoCircuitSwitchFulfilledAction extends AnyAction {
  type: typeof DELETE_UTIMACO_CIRCUIT_SWITCH_FULFILLED
  payload: AxiosResponse<ServerResponse<UtimacoCircuitSwitch>>
}

export interface DeleteUtimacoCircuitSwitchRejectedAction extends AnyAction {
  type: typeof DELETE_UTIMACO_CIRCUIT_SWITCH_REJECTED
  payload: AxiosResponse<ServerResponse<UtimacoCircuitSwitch>>
}

export interface SelectUtimacoCircuitSwitchAction extends AnyAction{
  type: typeof SELECT_UTIMACO_CIRCUIT_SWITCH
  payload: UtimacoCircuitSwitch[]
}

export type UtimacoCircuitSwitchActionTypes =
  GoToUtimacoCircuitSwitchListAction |
  SetUtimacoCircuitSwitchLoadingAction |
  GetUtimacoCircuitSwitchListAction |
  GetUtimacoCircuitSwitchListPendingAction |
  GetUtimacoCircuitSwitchListFulfilledAction |
  GetUtimacoCircuitSwitchAction |
  GetUtimacoCircuitSwitchPendingAction |
  GetUtimacoCircuitSwitchFulfilledAction |
  CreateUtimacoCircuitSwitchAction |
  CreateUtimacoCircuitSwitchPendingAction |
  CreateUtimacoCircuitSwitchFulfilledAction |
  CreateUtimacoCircuitSwitchRejectedAction |
  UpdateUtimacoCircuitSwitchAction |
  UpdateUtimacoCircuitSwitchFulfilledAction |
  UpdateUtimacoCircuitSwitchRejectedAction |
  DeleteUtimacoCircuitSwitchAction |
  DeleteUtimacoCircuitSwitchFulfilledAction |
  DeleteUtimacoCircuitSwitchRejectedAction |
  SelectUtimacoCircuitSwitchAction;
